import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { BookOpen, FileText, ExternalLink } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import stewModel from "../../../docs/STEW_MODEL.md?raw";
import stewAvatars from "../../../docs/STEW_AVATARS.md?raw";

const REPO = "https://github.com/wlthystwrd/wlthystwrd/blob/main";

const promptSources = [
  {
    path: "supabase/functions/manual-assistant/index.ts",
    label: "Member surface prompt",
  },
  {
    path: "supabase/functions/public-stew-chat/index.ts",
    label: "Prospect surface prompt",
  },
];

export default function StewBrain() {
  return (
    <div className="max-w-4xl mx-auto space-y-6 p-4 md:p-6">
      <header className="space-y-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-foreground">Stew's Brain</h1>
        <p className="text-muted-foreground">
          Five layers, every change a commit. This page is a window, never an editor; changes follow
          the ritual in the Owner's Manual.
        </p>
      </header>

      <Card>
        <CardContent className="pt-6">
          <div className="sop-markdown space-y-4 [&_h1]:text-xl [&_h1]:font-semibold [&_h2]:text-lg [&_h2]:font-semibold [&_p]:leading-relaxed [&_p]:text-foreground">
            <ReactMarkdown>{stewModel}</ReactMarkdown>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6">
          <div className="sop-markdown space-y-4 [&_h1]:text-xl [&_h1]:font-semibold [&_h2]:text-lg [&_h2]:font-semibold [&_p]:leading-relaxed [&_p]:text-foreground">
            <ReactMarkdown>{stewAvatars}</ReactMarkdown>
          </div>
        </CardContent>
      </Card>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-foreground">Live layers</h2>
        <div className="grid gap-4 md:grid-cols-3">
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-base flex items-center gap-2">
                <BookOpen className="h-4 w-4" /> Canon Register
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm">
              <Link to="/admin/canon" className="text-primary underline underline-offset-4">
                Open the canon
              </Link>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-base flex items-center gap-2">
                <FileText className="h-4 w-4" /> Corpus admin
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm">
              <Link
                to="/admin/briefing-corpus"
                className="text-primary underline underline-offset-4"
              >
                Open the corpus
              </Link>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-base flex items-center gap-2">
                <ExternalLink className="h-4 w-4" /> Prompt source
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm space-y-2">
              {promptSources.map((s) => (
                <div key={s.path}>
                  <a
                    href={`${REPO}/${s.path}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary underline underline-offset-4"
                  >
                    {s.label}
                  </a>
                  <p className="text-xs text-muted-foreground break-all">{s.path}</p>
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </section>

      <p className="text-sm text-muted-foreground">
        Learning loop per CANON-237: capture, weekly triage, patch the owning layer, no fix without a
        test.
      </p>
    </div>
  );
}
